import React, { useState } from "react";
import { List, Row, Col, Badge, theme } from "antd";
import { useCalculateListSizeForPaginationHook } from "../../../hooks";
import PropTypes from "prop-types";
import { reduceText } from "../../../utils/Formaters";
//import { admitedEntities } from "../utils";
import { hover_item } from "../../../hover";

export const EntitiesList = ({entities, onClientSelected}) => {
	const { pageSize } = useCalculateListSizeForPaginationHook(35);

	const { token: antToken } = theme.useToken();

	const [hoveredItem, setHoveredItem] = useState(null);

	const getSelectedClient = (client) => {
		if(onClientSelected){
			onClientSelected(client);
		}
	};

	const sortedEntities = [...entities].sort((a, b) => {
		return a.name.localeCompare(b.name); // Ordena por el nombre de A a Z
	});

	return (
		<List
			header={
				<Row
					style={{
						background: antToken.colorBgLayout,
						borderRadius: "10px"
					}}
				>
					<Col flex="auto">
						<List.Item key={0} >
							<List.Item.Meta 
								title="Nombre"
							/>
							<List.Item.Meta  
								style={{
									maxWidth: 250,
									textAlign:"center",
								}} 
								title="Estado" 
							/>
							<List.Item.Meta 
								style={{
									maxWidth: 250,
									textAlign:"right",
								}} 
								title="NIT" 
							/>
						</List.Item>
					</Col>
				</Row>
			}
			pagination={{
				position: "top",
				align: "center",
				disabled: false,
				showSizeChanger: false,
				pageSize: pageSize,
				showTotal:(total, range) => `${range[0]}-${range[1]} de ${total} Clientes`
			}}
			style={{
				textAlign: "start",
			}}
			size="small"
			dataSource={sortedEntities}
			renderItem={(item, index) => (
				<Row>
					<Col flex="auto">
						<List.Item
							style={hover_item(hoveredItem === index, antToken, "invoices", 45)}
							key={index}
							onMouseEnter={() => setHoveredItem(index)}
							onMouseLeave={() => setHoveredItem(null)}
							className={hoveredItem === index ? "hovered-item" : ""}
							onClick={() => getSelectedClient(item)}
						>
							<List.Item.Meta						
								description={<p style={{ color:  antToken.colorText }}>{reduceText(item.name, 60)}</p>}
								style={{
									fontWeight: hoveredItem === index ? 600 : 400,
								}}
							/>
							<List.Item.Meta
								style={{
									maxWidth: 250,
									textAlign: "center",
									fontWeight: 400, // reduce grosor de la letra
								}}
								description={
									<Badge 
										style={{
											fontWeight: hoveredItem === index ? 600 : 400,
											color: antToken.colorText
										}}
										status={item.state == "active"? "success" : "default"} 
										text={item.state == "active"?  "Activo" : "Archivado"} 
									/>
								}
							/>
							<List.Item.Meta
								style={{
									maxWidth: 250,
									textAlign: "right",
									fontWeight: hoveredItem === index ? 600 : 400,
								}}
								description={<p style={{ color: antToken.colorText }}>{item.entity_company_tid}</p>} // Cambia el color de la descripción
							/>
						</List.Item>
					</Col>
				</Row>
			)}
		></List>

	);
};

EntitiesList.propTypes = {
	entities: PropTypes.array.isRequired,
	onClientSelected: PropTypes.func,
	entitySelected: PropTypes.string.isRequired,
};